import { api } from '../core';
import { CHRONOLOGY_UNDO_REDO_HISTORY_TAG } from '../constants';
import { setTimelineChronologyUndoRedoHistory, TimelineChronologyType } from '@/store';

export interface ChronologyUndoRedoHistory {
  undone: number;
  applied: number;
}

type ChronologyUndoRedoHistoryResponse = ChronologyUndoRedoHistory;

type ChronologyUndoRedoHistoryProps = {
  caseId: string;
};

export const getChronologyUndoRedoHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChronologyUndoRedoHistory: builder.query<ChronologyUndoRedoHistoryResponse, ChronologyUndoRedoHistoryProps>({
      query: ({ caseId }: ChronologyUndoRedoHistoryProps) => {
        return {
          url: `chronology/history`,
          method: 'GET',
          params: {
            caseId: caseId
          }
        };
      },
      providesTags: (_result, _err, { caseId }) => [{ type: CHRONOLOGY_UNDO_REDO_HISTORY_TAG, id: caseId }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(
              setTimelineChronologyUndoRedoHistory({
                key: TimelineChronologyType.CHRONOLOGY,
                data: data
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getChronologyUndoRedoHistory in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetChronologyUndoRedoHistoryQuery } = getChronologyUndoRedoHistoryApi;
